'use client'

import Script from 'next/script'
import React, { useEffect, useRef } from 'react'

import { useCustomReferrer } from '@/shared/navigation'

import { useYandexMetricsActions } from './hooks/useYandexMetricsActions'
import { getMetricsScriptString } from './utils/getMetricsScriptString'

export type YandexMetricsProps = {
	ymID: string | number
	path: string
}

export const YandexMetrics = ({ ymID, path }: YandexMetricsProps): JSX.Element => {
	const { hit } = useYandexMetricsActions(ymID)
	const referrer = useCustomReferrer()

	const scriptString = getMetricsScriptString(ymID)

	const isFirstMount = useRef(true)
	const currentPath = useRef(path)

	useEffect(() => {
		// Отправляем hit только при изменении path или при первой загрузке
		// Игнорируем последующие изменения referrer, чтобы избежать двойной отправки
		if (isFirstMount.current || currentPath.current !== path) {
			hit({ referer: referrer || undefined })
			isFirstMount.current = false
			currentPath.current = path
		}
	}, [path, referrer, hit])

	const onError = () => {
		console.error('Error loading Yandex metrika script')
	}

	return (
		<Script id="yandex-metric-script" onError={onError}>
			{scriptString}
		</Script>
	)
}
